const portalCls = "_275p109423a";
const imgWrapperCls = "_275i1uykd5u";
const imgCls = "_275i4q8qqp";
const textWrapperCls = "_275t798pte";
const headingCls = "_275h1be66vq";
const gradeLevelCls = "_275g14c1krh";
const chevronCls = "_275cbmh4y";

export { chevronCls, gradeLevelCls, headingCls, imgCls, imgWrapperCls, portalCls, textWrapperCls };
import "./molecule.portal.style.linaria.module.css";
//# sourceMappingURL=molecule.portal.style.js.map
